import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const miniBetSlipStyles: MiniBetSlipSchema = {
  wrapper: {
    mx: ['0', null, '-4'],
    mb: ['0', null, '-4'],
    bottom: '0',
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
    bg: 'alpha.300',
    borderBottomRadius: 'md',
  },
  slideBox: {
    bg: 'alpha.300',
    color: 'white',
    borderTopWidth: '3px',
    borderTopColor: 'beta.300',
    borderBottomRadius: 'base',
  },
  accordionItem: {
    borderTop: '3px',
    borderColor: 'beta.300',
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    boxShadow:
      '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  },
  accordionButton: {
    bg: 'alpha.300',
    fontSize: 'xs',
    fontWeight: 'bold',
    fontFamily: 'accent',
    gap: '1',
    px: '2',
    py: '3',
    color: 'white',
    borderTop: '3px',
    borderColor: 'beta.500',
    _hover: {
      bg: 'alpha.600',
    },
  },
  accordionButtonIcon: {
    fontSize: 'sm',
    pos: 'relative',
  },
  headerStack: {
    bg: 'alpha.800',
    borderRadius: 'base',
    bottom: '100%',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    bg: 'alpha.500',
    fontSize: 'xs',
    maxH: '36',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'rgba(0, 0, 0, 0.25)',
    bg: 'alpha.500',
    gap: '2',
    p: '3',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dashed',
      borderTopWidth: '1px',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bg: 'blackAlpha.400',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    py: '2.5',
    px: '4',
    pos: 'relative',
    borderTopColor: 'blackAlpha.300',
    borderBottomRadius: 'md',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    _before: {
      opacity: '0.2',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '4',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '2xs',
  },
  legsChunks: {
    color: 'beta.300',
    fontFamily: 'accent',
    fontSize: 'xl',
    fontWeight: 'extrabold',
  },
  oddsText: {
    color: 'white',
    textTransform: 'uppercase',
    flex: '3',
    display: 'flex',
    fontWeight: 'bold',
    flexDirection: 'column',
    fontSize: '2xs',
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'beta.300',
    fontFamily: 'accent',
    fontSize: 'xl',
    fontWeight: 'bold',
  },
  clearButton: {
    variant: 'outline',
    fontSize: 'xs',
    textTransform: 'uppercase',
  },
  addToSlipButton: {
    variant: 'solid',
    fontSize: 'xs',
    textTransform: 'uppercase',
    px: ['1', '3'],
  },
  buttonsHStack: {
    gap: '0',
  },
};
